class VariantRadios extends HTMLElement {
  constructor() {
    super();

    this.form = this.parentElement;
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.addToCartButton = document.getElementById('add-to-bag-submit');
    this.variantInputs = this.querySelectorAll('input[type="radio"]');
    this.variantInputs.forEach((variantInput) => {
      variantInput.addEventListener('click', this.onVariantChange.bind(this));
      variantInput.nextElementSibling.addEventListener('keydown', (event) => {
        if (event.code === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          this.onVariantChange(event);
        }
      });
    });

    this.updateOptions();
    this.addToCartPanel = document.querySelector('[data-panel="add-to-cart"]');
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateVariantInput(event);
      this.handleVariantSelect(event);
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    const formData = new FormData(this.form);
    this.addToCartButton.textContent = window.translations.adding;
    this.form.classList.add('adding');
    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: `application/json` },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        this.form.classList.add('added');
        this.addToCartButton.textContent = window.translations.added;
        this.addToCartPanel.openCart();
        setTimeout(() => {
          this.form.classList.remove('added');
          this.form.classList.remove('adding');
          this.addToCartButton.textContent = window.translations.add_to_cart;
        }, 2000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.querySelectorAll('li').forEach((li) => {
          li.classList.remove('selected');
        });
      });
  }

  updateVariantInput(event) {
    const input = this.form.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const variantRadio = event.currentTarget;
    const leadTimeInput = this.form.querySelector('input[name="properties[Lead Time]"]');
    const leadTime = variantRadio.getAttribute('data-lead-time');
    if (leadTime) {
      leadTimeInput.value = leadTime;
      leadTimeInput.disabled = false;
    } else {
      leadTimeInput.value = '';
      leadTimeInput.disabled = true;
    }
    this.addToCartButton.classList.remove('hidden');
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  handleVariantSelect(event) {
    this.querySelectorAll('li').forEach((li) => {
      li.classList.remove('selected');
    });
    const li = event.currentTarget.parentElement;
    li.classList.add('selected');
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
